<template>
  <div class="status-test" :class="statusClass"></div>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      default: "",
    },
  },
  computed: {
    statusClass() {
      return this.status === "active" ? "green" : "grey";
    },
  },
};
</script>

<style lang="scss" scoped>
.status-test {
  width: 7px;
  height: 7px;
  flex-shrink: 0;
  border-radius: 100%;
}

.green {
  background-color: #67c23a;
}
.grey {
  background-color: #c7c9cc;
}
</style>
